import { Input } from "reactstrap";
import { Btn } from "../../AbstractElements";
import { Navigator } from "../Table/Defaultdata";
const style2 = { width: 60, fontSize: 14, padding: 4 };

export const PaymentTable = {
    header: ['Date', 'Type', 'Diagnosis', 'Treatment Done', 'Total', 'Pay'],
    // header: ['AD Platform', 'Campaign', 'GEO', 'Profitability', 'Max Participation Avai.', 'Status', 'Create'],
    body: [
      {
        Date: '05-05-2024',
        Type: 'General',
        Diagnosis: 'Gingitivity',
        TreatmentDone: 'Gross Hand Scaling',
        Total: '10000',
        // DiscountType: 'Discount',
        // Discount: '10 %',
        // DiscountedAmount: '6000',
        // Pay: <span><Input type="number"></Input></span>,
        // Edit: <span><Btn attrBtn={{ style: style2, color: 'primary', className: 'btn btn-xs', type: 'button',}}>Edit</Btn> </span>,
        // Due: 2000,
        // Paid: 8000,
        // Status: 'In-Due',
        pay: <span>{<Navigator to={`${process.env.PUBLIC_URL}/billing/:layout`} params={{ rowData: '' , btn: "pay"}}/>} </span>,
        // pay: <span>{<Navigator to={`${process.env.PUBLIC_URL}/billing/:layout`} params={{ rowData: row , btn: "pay"}}/>} </span>,
        // Invoice: <span><Btn attrBtn={{ style: style2, color: 'primary', className: 'btn btn-xs', type: 'button',}}>Invoice</Btn> </span>,
      },
    ],
  };